<template>
    <div id="ruleEnigeDetail">
         <a-row type="flex" justify="space-between" align="middle" style="margin: 4px 0">
             <a-col>
                 <img @click="addRuleEnige('add')" style="margin: 0 4px" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                 <img  class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                 <a-button
                     size="small"
                     type="primary"
                     style="margin: 0 4px"
                 >{{ $t('pubGicSet.Sort') }}</a-button>
             </a-col>
             <a-col v-if="false">
                 <a-pagination
                     :pageSizeOptions="page.pageSizeOptions"
                     :showTotal="total => `${$t('generic.totalOf')} ${page.pagingTotal} ${$t('generic.Records')}`"
                     size="small"
                     :total="page.pagingTotal"
                     v-model="page.currentVal"
                     :pageSize.sync="page.pagingSize"
                     @change="tableChangePage"
                     @showSizeChange="onShowSizeChange"
                     showSizeChanger
                     />
             </a-col>
         </a-row>
            <div  v-if="searchSortVis">
                <vxe-table
                    border
                    height="auto"
                    class="sortable-row-demo"
                    row-key
                    size="mini"
                    ref="ruleEnigeSortTable"
                    :data.sync="ruleEnigeData">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="40"></vxe-table-column>
                    <vxe-table-column field="fieldName" show-header-overflow="ellipsis" show-overflow="ellipsis"  :title="$t('pubGicSet.FieldName')"></vxe-table-column>
                </vxe-table>
            </div>
        <a-modal
            :title="$t('generic.Add')"
            v-model="ruleEnigeVis"
            width="60%">
            <template slot="footer">
                <a-button type="primary" @click="saveRuleEnige" size="small">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-row>
                <a-form :form="enigeForm">
                    <a-col :span="12">
                        <a-form-item :label="$t('pubGicSet.ColumnName')" v-bind="formItemLayout">
                            <a-select
                                :placeholder="$t('publicLang.PleaseSelect')"
                                 size="small" style="width: 100%"
                                 v-decorator="[
                                  'columnName',
                                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                                 ]">
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.Condition')" v-bind="formItemLayout">
                            <a-select
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    size="small"
                                    style="width: 100%"
                                    v-decorator="[
                                      'condition',
                                      {rules: [{ required: true, message: $t('publicLang.Required')  }]}
                                     ]">
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.SortSeq')" v-bind="formItemLayout">
                            <a-input-number
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width: 100%;"
                                v-decorator="['sortSeq',]"/>
                        </a-form-item>
                    </a-col>
                </a-form>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import Sortable from "sortablejs";
     import cookie from '../../../api/cookie';
    export default{
        data(){
            return{
                searchSortVis: false,
                page:{
                    pageSizeOptions: ['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal: 0,
                    pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                    currentVal: 1,
                },
//                table
                ruleEnigeData:[],
//                from
                ruleEnigeVis: false,
                enigeForm: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        created (){
            this.init()
        },
        methods:{
            init(){
                ajax.get(api.SEARCHSORT, { gmcUid: 452}).then(res => {
                    this.ruleEnigeData = res.data;
                    this.searchSortVis = true
                    this.rowDrop();
                });
            },
            //            推拽
            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.ruleEnigeSortTable
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        handle: '.drag-btn',
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.ruleEnigeData.splice(oldIndex, 1)[0];
                            this.ruleEnigeData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
            addRuleEnige(type){
                this.ruleEnigeVis = true
            },
            saveRuleEnige(){
                this.enigeForm.validateFields((err, values)=>{
                    if(!err){
                        return
                    }
                })
            }
        }
    }
</script>
<style lang="less">
    .sortable-row-demo .drag-btn {
        cursor: move;
        font-size: 12px;
    }
    .sortable-row-demo .vxe-body--row.sortable-ghost,
    .sortable-row-demo .vxe-body--row.sortable-chosen {
        background-color: #dfecfb;
    }
</style>